<div *ngIf="bannerList.length > 0" class="carousel">
  <a *ngIf="bannerList[currentIndex].imgLink" target="_blank" href="{{bannerList[currentIndex].imgLink}}"><img src="{{globalVar.targetIp}}/upload/{{bannerList[currentIndex].imgPath}}" alt="carousel image"></a>
  <img *ngIf="!bannerList[currentIndex].imgLink" src="{{globalVar.targetIp}}/upload/{{bannerList[currentIndex].imgPath}}" alt="carousel image">
  <div class="dots">
    <span *ngFor="let image of bannerList; let i = index" [class.active]="i === currentIndex" (click)="setCurrentIndex(i)"></span>
  </div>
  <button class="culbtn" (click)="prevImage()"><mat-icon>arrow_back_ios</mat-icon></button>
  <button class="culbtn" (click)="nextImage()"><mat-icon>arrow_forward_ios</mat-icon></button>
</div>
<br />
<div style="text-align:center;padding:0px 10px">
  <div style="display: inline-block; width: 32%; min-width: 300px; min-height: 150px; vertical-align: top;">
    <div style="margin: 20px; min-height: 150px; background-color: #fff; padding: 15px ">
      <div style="color: #219C90; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #219C90 ">
        現有學生人數
      </div>
      <div style="color: #000; font-weight: bold; font-size: 75px; text-shadow: 2px 2px 2px #888; text-align: center; height: 160px">
        <div style="line-height:150px">
          {{studentNumber}} <span style="font-size:35px">人</span>
        </div>
      </div>
      <div style="color: #219C90; font-weight: bold; font-size: medium; text-align: right">
        <button routerLink="/student/profile" mat-raised-button style="background-color: #219C90;color:#fff">詳細內容</button>
      </div>
    </div>
  </div>
  <div style="display: inline-block; width: 32%; min-width: 300px; min-height: 150px; vertical-align: top">
    <div style="margin: 20px; min-height: 150px; background-color: #fff; padding: 15px">
      <div style="color: #6895D2; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #6895D2 ">
        現有老師人數
      </div>
      <div style="color: #000; font-weight: bold; font-size: 75px; text-shadow: 2px 2px 2px #888; text-align: center; height: 160px">
        <div style="line-height:150px">
          {{teacherNumber}} <span style="font-size:35px">人</span>
        </div>       
      </div>
      <div style="color: #219C90; font-weight: bold; font-size: medium; text-align: right">
        <button routerLink="/teacher/profile" mat-raised-button style="background-color: #6895D2; color: #fff">詳細內容</button>
      </div>
    </div>
  </div>
  <div style="display: inline-block; width: 35%; min-width: 400px; min-height: 150px; vertical-align: top">
    <div style="margin: 20px; min-height: 150px; padding: 15px">
      <div style="color: #222; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #555 ">
        新註冊教師人力
      </div>
      <div style="color: #222; font-weight: bold; font-size: 18px; text-shadow: 0.3px 0.3px 0.3px #888; text-align: left; height: 160px ;padding-top:8px">
        <div *ngFor="let item of inviteList">
          <span style="display: inline-block; vertical-align: middle; width: 13px; height: 13px; background-color: #6895D2;border-radius:13px"></span>&nbsp;
          <span style="display: inline-block; vertical-align: middle; padding: 1px 5px; width: 120px">{{item.expertise.substring(0,5)}}...</span>
          <span style="display: inline-block; vertical-align: middle; padding: 1px 10px; width: 100px; border-left: 2px solid #888 ">{{item.name2.substring(0,1)}}*{{item.name2.substring(2,3)}}</span>
          <span style="display: inline-block; vertical-align: middle; padding: 1px 5px"><button (click)="openReadDialog(item)" style="background-color: #6895D2;color:#fff;padding:5px 10px;border:0">詳細內容</button></span>
        </div>
      </div>
      <div style="color: #219C90; font-weight: bold; font-size: medium; text-align: left">
        <button  routerLink="/teacher/invite" mat-raised-button style="background-color: #333; color: #fff">尋找更多老師</button>
      </div>
    </div>
  </div>
</div>

<div style="text-align: center; padding: 5px 10px ">
  <div style="margin: 10px 30px; min-height: 150px; background-color: #fff; padding: 15px">
    <div style="color: #E9B824; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #E9B824 ">
      班部老師當月調課情形
    </div>
    <div style="color: #000; font-weight: bold; font-size: 17px; text-shadow: 0.3px 0.3px 0.3px #888; text-align: left; min-height: 150px;width:100%">
      <div *ngFor="let item of teacherSituationList" style="margin:5px">
        <span style="display: inline-block; vertical-align: middle; width: 13px; height: 13px; background-color: #E9B824; border-radius: 13px"></span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px; ">{{item.nick}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px;  border-left: 2px solid #888 ">{{item.title}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 5px;">{{item.memo1}}</span>
      </div>
    </div>
    <div style="color: #E9B824; font-weight: bold; font-size: medium; text-align: right">
      <button routerLink="/class/course" mat-raised-button style="background-color: #E9B824; color: #fff">詳細內容</button>
    </div>
  </div>
</div>

<div style="text-align: center; padding: 5px 10px ">
  <div style="margin: 10px 30px; min-height: 150px; background-color: #fff; padding: 15px">
    <div style="color: #EE9322; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #EE9322 ">
      班部學生當月請假情形
    </div>
    <div style="color: #000; font-weight: bold; font-size: 17px; text-shadow: 0.3px 0.3px 0.3px #888; text-align: left; min-height: 150px">
      <div *ngFor="let item of studentLeaveList" style="margin:5px">
        <span style="display: inline-block; vertical-align: middle; width: 13px; height: 13px; background-color: #EE9322; border-radius: 13px"></span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px; ">{{item.studentName}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px;  border-left: 2px solid #888 ">{{item.courseName}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 5px;">{{item.start}}-{{item.end_.substring(11,16)}}&nbsp;&nbsp;{{item.memo1}}</span>
      </div>
    </div>
    <div style="color: #EE9322; font-weight: bold; font-size: medium; text-align: right">
      <button routerLink="/student/profile" mat-raised-button style="background-color: #EE9322; color: #fff">詳細內容</button>
    </div>
  </div>
</div>

<div style="text-align: center; padding: 5px 10px ">
  <div style="margin: 10px 30px; min-height: 150px; background-color: #fff; padding: 15px">
    <div style="color: #D83F31; font-weight: bold; font-size: 20px; text-align: left; text-shadow: 0.3px 0.3px 0.3px #D83F31 ">
      尚未繳費名單
    </div>
    <div style="color: #000; font-weight: bold; font-size: 17px; text-shadow: 0.3px 0.3px 0.3px #888; text-align: left; min-height: 150px">
      <div *ngFor="let item of nonTuitionList" style="margin:5px">
        <span style="display: inline-block; vertical-align: middle; width: 13px; height: 13px; background-color: #D83F31; border-radius: 13px"></span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px; ">{{item.name}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 10px;  border-left: 2px solid #888 ">{{item.labelName}}</span>
        <span style="display: inline-block; vertical-align: middle; padding: 1px 5px;">學費尚未繳交</span>
      </div>
    </div>
    <div style="color: #D83F31; font-weight: bold; font-size: medium; text-align: right">
      <button routerLink="/student/profile" mat-raised-button style="background-color: #D83F31; color: #fff">詳細內容</button>
    </div>
  </div>
</div>

<br />
<br />
<br />
